import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function NervousSystemSection() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section className="py-24 px-6" style={{ background: '#0B1525' }}>
      <div
        ref={ref}
        className="max-w-3xl mx-auto"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0)' : 'translateY(28px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="rounded-3xl overflow-hidden w-full h-80 border" style={{ borderColor: 'rgba(0,200,232,0.12)' }}>
            <img
              src="https://public.readdy.ai/ai/img_res/405978c92e9464036b74d534f9bbace9.jpg"
              alt="Sistema nervoso e regulação emocional"
              className="w-full h-full object-cover object-top"
            />
          </div>

          {/* Text */}
          <div>
            <span
              className="inline-block text-xs font-semibold tracking-widest uppercase px-4 py-2 rounded-full mb-6 border"
              style={{ background: 'rgba(0,200,232,0.08)', color: '#00C8E8', borderColor: 'rgba(0,200,232,0.2)' }}
            >
              Compreendendo seu sistema
            </span>
            <h2 className="text-3xl font-semibold leading-tight mb-6 text-white">
              O que você sente não é fraqueza — é proteção
            </h2>
            <div className="space-y-4">
              {[
                'Muitas respostas emocionais intensas não significam que há algo errado com você.',
                'Frequentemente são sinais de um sistema nervoso que permaneceu em estado de alerta por tempo demais.',
                'Quando o corpo não percebe segurança, a mente acelera tentando proteger você.',
                'A regulação emocional ajuda o sistema nervoso a recuperar equilíbrio e sensação de segurança interna.',
              ].map((text, i) => (
                <p key={i} className="text-base leading-relaxed" style={{ color: '#B8D4E8' }}>
                  {text}
                </p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}